import * as types from './actionTypes';

const hideNav = (payload) => ({ type: types.HIDE_NAV, payload });

export default hideNav;
